import { useEffect, useRef } from 'react';
import { init } from '@blotoutio/edgetag-sdk-js';

const BLOTOUT_DOMAIN = import.meta.env['VITE_BLOTOUT_DOMAIN'];

export function Blotout() {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!BLOTOUT_DOMAIN || initializedRef.current) return;

    init({ edgeURL: BLOTOUT_DOMAIN });
    initializedRef.current = true;
  }, []);

  return null;
}
